import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import {
  PageSection,
  PageSectionVariants,
  Title,
  Grid,
  GridItem,
} from "@patternfly/react-core";
import isEmpty from "lodash/isEmpty";
import EmptyState from "../components/general/EmptyState";
import ProductTab from "../components/product/ProductTab";
import ProductGroupToolbar from "../components/productGroup/ProductGroupToolbar";
import ProductGroupGallary from "../components/productGroup/ProductGroupGallary";
import { REQUESTED_PRODUCT_GROUPS } from "../redux/actions/productGroupAction";
import { keyValueFilter } from "../utils/filterUtil";

export default () => {
  const mapState = useCallback(
    (state) => ({
      productGroups: state.productGroupState.productGroups,
      isFetchingProductGroups: state.productGroupState.isFetchingProductGroups,
    }),
    []
  );
  const { productGroups, isFetchingProductGroups } = useMappedState(mapState);
  const dispatch = useDispatch();

  const [itemCount, setItemCount] = useState(0);
  const [filterValue, setFilterValue] = useState("");

  const filterProductGroups = useCallback(() => {
    return keyValueFilter(productGroups, "name", filterValue);
  }, [productGroups, filterValue]);

  // fetch productGroups
  useEffect(() => {
    if (!productGroups && !isFetchingProductGroups) {
      dispatch({
        type: REQUESTED_PRODUCT_GROUPS,
        payload: {},
      });
    }
    const filteredGroup = filterProductGroups();
    if (filteredGroup) {
      setItemCount(filteredGroup.length);
    }
    setFilteredProductGroups(filteredGroup);
  }, [dispatch, productGroups, isFetchingProductGroups, filterProductGroups]);

  function handleFilterValueChange(filterValue) {
    setFilterValue(filterValue);
  }

  // filter product suites
  const [filteredProductGroups, setFilteredProductGroups] = useState(
    productGroups
  );
  const [pageContent, setPageContent] = useState(productGroups);

  useEffect(() => {
    const filteredGroup = filterProductGroups();
    if (filteredGroup) {
      setItemCount(filteredGroup.length);
    }
    setFilteredProductGroups(filteredGroup);
  }, [filterValue, filterProductGroups]);

  useEffect(() => {
    if (filteredProductGroups) {
      setPageContent(filteredProductGroups);
    }
  }, [filteredProductGroups]);

  function renderProductGroupTables() {
    if (
      isEmpty(productGroups) ||
      isEmpty(filteredProductGroups) ||
      isEmpty(pageContent)
    ) {
      return <EmptyState isFetching={isFetchingProductGroups} />;
    } else {
      return <ProductGroupGallary productGroups={pageContent} />;
    }
  }

  return (
    <>
      <PageSection variant={PageSectionVariants.light}>
        <ProductTab />
        <Title headingLevel="h1" size="4xl" className="pf-c-title--PaddingTop">
          Red Hat Product Group
        </Title>
      </PageSection>
      <PageSection>
        <Grid hasGutter>
          <GridItem span={12} key={1}>
            <ProductGroupToolbar
              handleFilterValueChange={handleFilterValueChange}
              itemCount={itemCount}
              page={1}
              perPage={10}
              setPageContent={setPageContent}
              allPageContent={filteredProductGroups}
            />
            {renderProductGroupTables()}
          </GridItem>
        </Grid>
      </PageSection>
    </>
  );
};
